import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useController, UseControllerProps } from 'react-hook-form'
import { FormHelperText, IconButton, InputAdornment, ListItemText, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { formControlColour, tooltipColour } from '../BEE123.Constants';

export interface IDropDownOptionsWithDescription {
    id: string | number,
    value: string,
    description: string
}
interface IProps extends UseControllerProps {
    label: string;
    items: IDropDownOptionsWithDescription[];
    size?: "small" | "medium";
    disabled?: boolean;
    disabledItems?: (string | number)[];
    onChange?: (value: any) => void;
}



const AppSelectListWithInfo = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: props.defaultValue != null ? props.defaultValue : '' });
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <InputLabel disabled={props.disabled}>{props.label}</InputLabel>
            <Select
                open={open}
                value={field.value}
                label={props.label}
                onChange={(value) => {
                    field.onChange(value);
                    if (props.onChange) {
                        if (value != null) {
                            const option = value.target.value;
                            props.onChange(option);
                        }
                    }
                }}
                onClose={handleClose}
                onOpen={handleOpen}
                sx={{
                    padding: "0.75rem 0 !important",
                    fontSize: "0.875rem"
                }}
                size={props.size}
                disabled={props.disabled}
                renderValue={(selected) => {
                    const selectedItem = props.items.find((item) => item.id === selected);
                    return selectedItem ? selectedItem.value : '';
                }}
                endAdornment={
                    field.value !== null && (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => {
                                    field.onChange(props.defaultValue != null ? props.defaultValue : null);
                                }}
                                disabled={props.disabled}
                            >
                                <ClearIcon />
                            </IconButton>
                            <IconButton
                                style={{ paddingLeft: "0px" }}
                                onClick={handleOpen}
                                disabled={props.disabled}
                            >
                                <ArrowDropDownIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }
            >
                {props.items.map((item) => (
                    <MenuItem key={item.id} value={item.id} disabled={props.disabledItems?.includes(item.id)}>
                        <ListItemText
                            primaryTypographyProps={{ fontSize: "0.875rem" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                            primary={item.value}
                            secondary={item.description.length > 50 ? `${item.description.slice(0, 50)}...` : item.description} />
                        {
                            item.description.length > 50 &&
                            <Tooltip
                                title={item.description}
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: tooltipColour,
                                            '& .MuiTooltip-arrow': {
                                                color: tooltipColour
                                            },
                                        },
                                    },
                                }}>
                                <IconButton
                                    size="small"
                                    edge="end"
                                    color="inherit"
                                    aria-label="info"
                                >
                                    <InfoOutlinedIcon style={{ color: formControlColour }} />
                                </IconButton >
                            </Tooltip>
                        }
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
    )
}

export default AppSelectListWithInfo